export function b64DecodeUnicode(str: string) {
  return decodeURIComponent(
    Array.prototype.map.call(atob(str), c =>
      '%' + c.charCodeAt(0).toString(16).padStart(2, '0')
    ).join('')
  );
}
